//@action
const actionTypes = require('constants/actionTypes');

const setCardBenefitsList = cardType => ({
    type: actionTypes.CARD_BENEFITS_SET_BENEFIT_LIST,
    payload: {
        cardType: cardType
    }
});

module.exports = {
    setCardBenefitsList
};